import React from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import ReasonItem from "./ReasonItem";
import styles from "./style.module.css";
import { financeNumberFormat } from "../../../utils/formatters";
import TextField from "@material-ui/core/TextField/TextField";
import { CancelReasonType } from "../../../constants/CancelReasonType";

export default React.memo((props) => {

  const { open, reasonModal, openReasonModal, baseRate, handleCancelRide, closeModal, selectedReason, setSelectedReason, commentReason, setCommentReason } = props;

  React.useEffect(() => {
    if (!CancelReasonType.some((item) => item.reasonType === selectedReason)) {
      const data = CancelReasonType?.find?.(x => x);
      setSelectedReason(data.reasonType);
    }
  }, [ selectedReason ]);

  return (
    <Dialog PaperProps={{ className: styles.container }} open={open} onClose={closeModal}>
      <DialogTitle id="form-dialog-title">
        <div className={styles.formTitle}>
          {reasonModal ? "Cancellation reason" : "Cancellation fee"}
        </div>
      </DialogTitle>
      <DialogContent>
        <div className={styles.cancelContent}>
          {!reasonModal ?
            `Cancellation of the ride is payable. Your account will be charged for $${financeNumberFormat(baseRate || 0)}` :
            <>
              <div className={styles.reasonList}>
                {CancelReasonType.map((item) =>
                  <ReasonItem
                    key={item.reasonType}
                    reasonName={item.reasonName}
                    reasonType={item.reasonType}
                    selectReason={setSelectedReason}
                    currentReason={item.reasonType === selectedReason}
                  />,
                )}
              </div>
              <div className={styles.reasonComment}>
                <TextField
                  value={commentReason}
                  placeholder="Your comment (optional)"
                  variant="outlined"
                  autoFocus={false}
                  multiline
                  rows={2}
                  onChange={(event) => setCommentReason(event.target.value)}
                />
              </div>
            </>}
        </div>
      </DialogContent>
      <DialogActions>
        <div className={styles.formButtonBlock}>
          <Button type='button'
                  variant='contained'
                  className={styles.formButtonCancel}
                  onClick={() => {
                    if (!reasonModal) {
                      openReasonModal(true);
                    } else {
                      handleCancelRide();
                    }
                  }}
          >
            Cancel Ride
          </Button>
          <Button type='submit'
                  variant='contained'
                  className={styles.formButtonSave}
                  onClick={closeModal}
          >
            Keep Ride
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
});
